import React from 'react';

import type { YesNoBooleanFormValue } from '@customTypes/form';

import FieldLabel from '../components/common/FieldLabel';
import YesNoGroup from '../components/common/YesNoGroup';

type Props = {
  questionTexts: Record<string, string>;
  values: { questionnaire?: Record<string, YesNoBooleanFormValue> };
  showErrors: boolean;
  errors: Record<string, string>;
  update: (path: string, val: unknown) => void;
};

export default function QuestionnaireStep({ questionTexts, values, showErrors, errors, update }: Props) {
  return (
    <div className='form-grid'>
      <div className='questions field-span-2'>
        {Object.keys(values.questionnaire || {}).map(qid => (
          <div key={qid} className='field outlined'>
            <FieldLabel required>{questionTexts[qid] || qid.replace('QNR_FHX_', 'Question ')}</FieldLabel>
            <YesNoGroup
              value={values.questionnaire?.[qid] || ''}
              onChange={val => update(`questionnaire.${qid}`, val)}
              ariaLabel={qid}
            />
            {showErrors && errors[`questionnaire.${qid}`] ? <div className='po-error inline'>Required</div> : null}
          </div>
        ))}
      </div>
    </div>
  );
}
